// Vue
import {mixins} from 'vue-class-component'
import {Vue, Component, Prop, Inject, Watch, Provide} from 'vue-property-decorator'

// Template
import template from './template.vue'

// Components
import {Checkbox} from './../../checkbox/Checkbox'

// Mixins
import {EventBus} from '../../../../mixins/event_bus/EventBus'

@Component({
    name: 'SelectGroup',
    components: {Checkbox},
    mixins: [
        template,
    ]
})
export class SelectGroup extends mixins(EventBus) {

    private groupValues: string[] = []

    @Prop()
    public title!: string

    @Prop({default: false})
    public hasCheckbox!: boolean

    private isChecked: boolean = false

    public created() {
        this.$on('change', this.handleModelChange)
        this.$on('registerValue', this.registerValue)
    }

    public destroyed() {
        this.$off('change', this.handleModelChange)
        this.$off('registerValue', this.registerValue)
    }

    public registerValue( newValue: string )
    {
        this.groupValues.push( newValue )
    }

    public handleModelChange(model: any) {
        if( !this.hasCheckbox || this.groupValues.length <= 1 || !(model instanceof Array) )
        {
            return
        }

        let includesAll = true
        this.groupValues.forEach((val)=>{
            if( !model.includes(val) )
            {
                includesAll = false
                return
            }
        });
        this.isChecked = includesAll
    }

    public handleSelectGroupItems( isSelected: boolean ) {
        this.dispatch('Select', 'groupChange', [this.groupValues, isSelected])
    }
}